<template>
  <div>
    <header-bar></header-bar>
    <div class="feedback" id="rave_reviews">
      <img
        src="https://static4.coolbrainscience.cn/e3df2823862044499b587c15dc0fa473.png"
        class="feedback_bg"
      />
      <div class="part_1">
        <div class="part_1_content1">
          <div class="part_1_t1">精力舱用户反馈</div>
          <div class="part_1_t2">般意精力舱 大脑的充电站 真实的用户好评</div>
        </div>
        <div class="part_1_content2">
          <div class="part_1_left">
            <!-- <img v-for="item in leftImg" :src="require('../../assets/'+item.imgSrc)"> 485vw-->
            <img
              src="https://static4.coolbrainscience.cn/6d0334416a0046028e10b5bb3d69d68a.png"
              style="height: 17vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/347622b0ffbc42d693047a2d704bfe44.png"
              style="height: 28vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/6f402178dc274014b6e7a9b063a3cf0f.png"
              style="height: 19vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/5296eb3df12a432da0d13cb8e10b5c86.png"
              style="height: 69vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/87a38e4e9b9a411690068abbe3125f3f.png"
              style="height: 57vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/f87ba592e2a24ccb97943aaa2bb75827.png"
              style="height: 127vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/3f58f145ff9c496caaec4b32d101babb.png"
              style="height: 39vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/ad1ca08f39de4ac38d326942fb61c190.png"
              style="height: 51vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/0ad74b84d46e49c6b5787c22ca89e715.png"
              style="height: 31vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/21ce8cce0b1944eab5e5db41c9c2d6e8.png"
              style="height: 47vw"
            />
          </div>
          <div class="part_1_right">
            <!--472-->
            <img
              src="https://static4.coolbrainscience.cn/e483ab758f9b4ec1ba66f23f30b22307.png"
              style="height: 16vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/f3d9504373f44796bdfdd35b78c8b3cb.png"
              style="height: 25vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/db511043198a43ea8555abb450724599.png"
              style="height: 53vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/42bf03eb85f64a83b10ea7e0d6fca99b.png"
              style="height: 47vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/56965c5efb6b49cb95498e075721d199.png"
              style="height: 33vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/7b998f03936040e7bcbbe3b4e86dce9a.png"
              style="height: 63vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/bd895284eb3042de847edb5a986f6076.png"
              style="height: 31vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/ba54d3be87c44c5aadc155e2abd06240.png"
              style="height: 24vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/62e0736d49e14634a918a67d18dd2ef0.png"
              style="height: 24vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/3dfc322301f84ec5a7220a41d7368e9b.png"
              style="height: 29vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/efd55aaf48e44896a26bff9ca61d78b7.png"
              style="height: 45vw"
            />
            <img
              src="https://static4.coolbrainscience.cn/647d83a1cbe84daf8c6073e8cabe6d66.png"
              style="height: 82vw"
            />
            <!-- <img v-for="item in rightImg" :src="require('../../assets/'+item.imgSrc)"> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="mask" v-if="show">
      <div class="maskContent">
        <img class="maskImg" :src="require('./../../assets/kefu.png')" />
        <img @click="show = false" class="closeImg" :src="require('./../../assets/close.png')" />
      </div>
    </div>
    <div class="tab3">
      <div class="tab3Title">
        超过2000万人正在通过
        <br />冥想受益
      </div>
      <div class="tab3Content">
        目前全球有超过2000万人在练习冥想，早在2003年《商业周刊》就提到财富500强的CEO很多把冥想作为心理保健的途径。
      </div>
      <div class="tab3Content">
        <img class="tab3Img" :src="require('./../../assets/19.png')" />
      </div>
      <img class="tab3Img1" :src="require('./../../assets/15.png')" />

      <div style="text-align: center">
        <img class="tab3Img2" :src="require('./../../assets/yao.png')" />
        <div class="tab3button" @click="show = true">预约导师</div>
      </div>
      <div style="text-align: center">
        <img class="tab3Img3" :src="require('./../../assets/yang.png')" />
        <div class="tab3button" @click="show = true">预约导师</div>
      </div>
      <div style="text-align: center">
        <img class="tab3Img4" :src="require('./../../assets/wang.png')" />
        <div class="tab3button" @click="show = true">预约导师</div>
      </div>
      <div style="text-align: center">
        <img class="tab3Img5" :src="require('./../../assets/chang.png')" />
        <div class="tab3button" @click="show = true">预约导师</div>
      </div>
      <div style="text-align: center">
        <img class="tab3Img5" :src="require('./../../assets/ming.png')" />
        <div class="tab3button" @click="show = true">预约导师</div>
      </div>
      <div style="text-align: center; margin-bottom: 6.9vw">
        <img class="tab3Img5" :src="require('./../../assets/song.png')" />
        <div class="tab3button" @click="show = true">预约导师</div>
      </div>
    </div> -->
    <footer-info></footer-info>
  </div>
</template>
<script>
import axios from "axios";
import footerInfo from "@/components/common/FooterInfo";
import headerBar from "@/components/common/HeaderBar";
export default {
  data() {
    return {};
  },
  components: {
    footerInfo,
    headerBar,
  },
  created() {
    this.$nextTick(() => {
      this.toLocal();
    });
  },
  mounted: function () {},
  methods: {
    toLocal() {
      let Id = window.sessionStorage.getItem("toId");
      if (Id) {
        let toElement = document.getElementById(Id);
        toElement.scrollIntoView();
      }
    },
  },
  // destroyed() {
  //   window.sessionStorage.setItem('toId', '')
  // },
};
</script>
<!-- <style src="@/components/common/sleep.css" scoped></style> -->
<style scoped>
.feedback_bg {
  width: 100vw;
  height: 71.5vw;
}

.part_1 {
  text-align: left;
  margin: -55.47vw 14vw 4.8vw 14vw;
  position: relative;
}

.part_1_t1 {
  color: #ffffff;
  font-weight: bold;
  font-family: "SourceHanSansCN-Bold";
  font-size: 3.125vw;
}

.part_1_t2 {
  color: #f3f4fe;
  font-weight: 300;
  font-family: "SourceHanSansCN-Light";
  font-size: 1.67vw;
  margin-top: 1.6vw;
}

.part_1_content2 {
  background: #f3f4fe;
  margin-top: 1.67vw;
  padding: 3.2vw 3vw 5vw 3vw;
  overflow: hidden;
}

.part_1_left {
  float: left;
  width: 32.6vw;
}

.part_1_left img,
.part_1_right img {
  width: 100%;
}

.part_1_right {
  float: right;
  width: 32.6vw;
}
</style>
<!--<style scoped>
  @font-face {
    font-family: 'fontmedium';
    src: url('../../font/SourceHanSansSC-Bold.otf')format('opentype');
  }

  @font-face {
    font-family: 'fontregular';
    src: url('../../font/SourceHanSansSC-Regular.otf')format('opentype');
  }

  .tab3 {}

  .tab3Title {
    text-align: right;
    width: 47vw;
    padding-left: 8.6vw;
    padding-top: 14.8vw;
    font-size: 4.1vw;
    font-family: 'fontmedium';
    font-weight: 500;
    color: #000000;
    line-height: 4.8vw;
  }

  .tab3Content {
    text-align: right;
    width: 47vw;
    padding-left: 8.6vw;
    padding-top: 1.2vw;
    font-size: 1.4vw;
    font-family: 'fontmedium';
    font-weight: 400;
    color: #000000;
    line-height: 2vw;
  }

  .tab3Img {
    width: 47.7vw;
    height: 27vw;
  }

  .tab3Img1 {
    height: 60.5vw;
    width: 40.4vw;
    position: absolute;
    top: 10.2vw;
    right: 8.1vw;
    z-index: -1;
  }

  .tab3Img2 {
    margin-top: 21vw;
    margin-bottom: 2.3vw;
    /* height: 52.6vw; */
    width: 70.5vw;
  }

  .tab3Img3 {
    margin-top: 8.6vw;
    margin-bottom: 2.2vw;
    width: 60.5vw;
    /* height: 40.4vw; */
  }

  .tab3Img4 {
    margin-top: 9.4vw;
    margin-bottom: 2.1vw;
    /* height: 51.3vw; */
    width: 77.7vw;
  }

  .tab3Img5 {
    margin-top: 8.6vw;
    margin-bottom: 2.2vw;
    width: 61vw;
  }

  .tab3button {
    width: 8.1vw;
    height: 2.7vw;
    background: #233923;
    border-radius: 2.2vw;
    text-align: center;
    margin: 0 auto;
    font-size: 1.2vw;
    font-family: 'fontregular';
    font-weight: 400;
    color: #ffffff;
    line-height: 2.7vw;
    cursor: pointer;
  }

  .tab {
    color: #000 !important;
  }

  .mask {
    background: rgba(0, 0, 0, 0.5);
    z-index: 4;
    height: 100%;
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    text-align: center;
  }

  .maskContent {
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
    text-align: left;
    margin-top: 10vw;
    box-sizing: border-box;
    position: relative;
  }

  .maskImg {
    width: 27.9vw;
    height: 32.4vw;
    border-radius: 1.2vw;
    box-shadow: 0 0.1vw 1vw 0 rgb(0 0 0 / 10%);
  }

  .closeImg {
    position: absolute;
    right: 1.1vw;
    top: 1.1vw;
    width: 1.1vw;
    height: 1.1vw;
  }
</style>-->



// WEBPACK FOOTER //
// src/components/pages/Sleep.vue